import React from 'react';
import { InView } from 'react-intersection-observer';

const AboutUs = () => {
  return (
    <div className='bg-gray-900 py-20'>
      <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center gap-12">
        {/* Left Section - Content */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`lg:w-1/2 text-left ${inView ? 'animate__animated animate__fadeInLeft' : 'opacity-0'}`}
            >
              <h2 className="text-4xl sm:text-5xl font-bold mb-8">
                <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                  About Edit Ezy
                </span>
              </h2>
              <div className="space-y-6">
                <p className="text-gray-300 text-lg leading-relaxed">
                  Edit Ezy was created with one simple goal—to make professional marketing and festival poster creation accessible to everyone.
                </p>
                <p className="text-gray-400 text-lg leading-relaxed">
                  We understand that small businesses, entrepreneurs, shop owners, agencies, and content creators don't always have the time or budget to hire designers every day. That's why we built an all-in-one platform where beautiful, ready-to-share designs are always ready.
                </p>
                <p className="text-gray-400 text-lg leading-relaxed">
                  From festivals and business promotions to greetings and branding, Edit Ezy helps you maintain a strong online presence effortlessly.
                </p>
                <p className="text-gray-400 text-lg leading-relaxed">
                  Our intelligent AI tools and ready-made templates allow anyone to create high-quality social media content within minutes.
                </p>
                <p className="text-gray-300 text-lg font-semibold">
                  With Edit Ezy, creativity becomes simple, fast, and affordable.
                </p>
              </div>
            </div>
          )}
        </InView>

        {/* Right Section - Image */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`lg:w-1/2 flex justify-center ${inView ? 'animate__animated animate__fadeInRight' : 'opacity-0'}`}
            >
              <img
                src="https://static.vecteezy.com/system/resources/thumbnails/012/939/271/original/animated-presentation-isolated-scene-strategy-meeting-business-plan-looped-flat-2d-characters-4k-footage-with-alpha-channel-colorful-illustration-for-mobile-website-animation-video.jpg"
                alt="About Edit Ezy"
                className="w-full h-auto max-w-xl object-cover rounded-2xl shadow-2xl shadow-purple-500/20"
              />
            </div>
          )}
        </InView>
      </div>
    </div>
  );
};

export default AboutUs;